module.exports = {"href":"/corgi/pageapps/prepurchase/_next/public/sprite-7.28.0-f3d742a11.svg#wishlist-v2","viewBox":"0 0 14 13"}